var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"deep-orange--text"},[_vm._v("體積重量")]),_vm._v("計算方法："),_c('br'),_vm._v(" 空運包裹長x寬x高/6000=體積重量"),_c('br'),_vm._v(" 體積重量與實際重量取較大的重量計重"),_c('br'),_vm._v(" 體積重量大於實際重量3倍以內全部優惠（即按實際重量計重）"),_c('br'),_vm._v(" 體積重量大於實際重量3倍以上享有50%優惠（即按體積重量/2計重） ")])
}]

export { render, staticRenderFns }